<div class="cost-chart">
    <div class="chart-header">
        <div class="chart-header--title align-right">{{chartYear}}</div>
        <div class="chart-header--title">
            {{ chartTitle }} {{unitOfMeasure}}
        </div>
    </div>

    @for (item of costData; track item.category) {
    @if (item.category) {
    <div [id]="'cost-chart-item-' + item.category"
        class="chart-item">
        <div class="chart-item__container">
            <div>
                <div class="chart-item--value">{{ (item.value || 0) | number:'1.2-2' }}</div>
                <div *ngIf="item.value < 0"
                    class="color-bar floatRight"
                    [ngClass]="item.category"
                    [style.width.%]="item.value ? item.value / maxNegValue * 100 : 0">
                </div>
            </div>

            <div class="chart-item--bar">
                <div>{{ 'task.unit.header' + item.category + 'Amount' | blah }}</div>
                @if (item.value >= 0) {
                <div class="color-bar"
                    [ngClass]="item.category"
                    [style.width.%]="item.value ? item.value / maxValue * 100 : 0">
                </div>
                }
            </div>
        </div>
    </div>
    }
    }
</div>